import { z } from 'zod';
import { SlackNotificationEventType } from '../constants';

export const slackNotificationChannelSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type SlackNotificationChannelSchema = z.infer<typeof slackNotificationChannelSchema>;

export const slackNotificationSettingsSchema = z.object({
  id: z.string().nullable(),
  agencyId: z.string(),
  isSlackConnected: z.boolean(),
  slackChannelId: z.string().nullable(),
  slackChannelName: z.string().nullable(),
  enabledEvents: z.array(z.nativeEnum(SlackNotificationEventType)),
  updatedAt: z.coerce.date().nullable(),
});

export type SlackNotificationSettingsSchema = z.infer<typeof slackNotificationSettingsSchema>;

/** A client's Slack channel override for client-scoped events; null channel fields mean "use the agency's general channel". */
export const clientSlackNotificationChannelSchema = z.object({
  clientId: z.string(),
  clientName: z.string(),
  slackChannelId: z.string().nullable(),
  slackChannelName: z.string().nullable(),
});

export type ClientSlackNotificationChannelSchema = z.infer<
  typeof clientSlackNotificationChannelSchema
>;
